import Requests from './requests'

export default class Sessions extends Requests {

  /**
  * Returns if the session is already expired
  * @returns {boolean} - `true` if session expired or not session
  **/
  tokenExpired () {
    return this.tokenTTL() > 0
  }

  /**
  * Returns the remaining seconds until session expire
  * @returns {number} - amount of remaining seconds
  **/
  tokenTTL () {
    var d = new Date()
    var now = Math.round(d.getTime() / 1000)
    return now - this.backd._security['expires_at']
  }

  /**
  * Signs In a user using email/password strategy
  * @param {string} loginRequest - Object with the credentials (email/password)
  * @returns {object}            - login response object
  *
  * loginRequest:
  * {
  *   "email": "...",
  *   "password": "..."
  * }
  *
  *
  * {
  *   "success": (true|false),   (true if sucessful)
  *   "err": ''                  (not empty if error)
  * }
  */
  signIn (loginRequest) {

    var that = this

    return this.backd._axios({
      method: 'post',
      url: that._url(),
      data: loginRequest,
      headers: {},
      params: {}
    })
      .then(function (response) {
        that.backd.setToken(response.data.token)
        that.backd.setRefreshToken(response.data.refresh_token)
        that.backd.setExpiresAt(response.data.expires_at)
        return {
          success: true,
          err: ''
        }
      })
      .catch(function (err) {
        return {
          success: false,
          err: err.response.status
        }
      })

  }

  /**
  * Signs Out a user
  * @returns {boolean} - successful boolean
  */
  signOut () {

    var that = this

    return this.backd._axios({
      method: 'delete',
      url: that._url(),
      data: null,
      headers: that._headerAuthorization(),
      params: {}
    })
      .then(function (response) {
        that.backd.clearSecurity()
        return true
      })
      .catch(function () {
        return false
      })

  }

  /**
  * Allow to refresh to token to ensure it can be used without sign in again
  * @returns {boolean} - `true` if token could be refreshed
  **/
  refreshToken () {

    var that = this

    var data = {
      refresh_token: that.backd._security.refresh_token
    }

    return this.backd._axios({
      method: 'put',
      url: that._url(),
      data: data,
      headers: that._headerAuthorization(),
      params: {}
    })
      .then(function (response) {
        if (response.status === 200) {
          that.backd.setToken(response.data.token)
          that.backd.setRefreshToken(response.data.refresh_token)
          that.backd.setExpiresAt(response.data.expires_at)
        }
        return true
      })
      .catch(function () {
        return false
      })
  }

}



// WEBPACK FOOTER //
// ./src/sessions.js